import { defineStore } from 'pinia';
import { ref } from 'vue';

import type { Coordinate } from '@libs/constraint-builder';

import { IpApiService } from '../services/ipApiService/ipApiService';
import { UserCoordinatesSource } from '../models/geolocation';

import { useBrowserStore } from './browserStore';

export const useGeolocationStore = defineStore('GeolocationStore', () => {
  const browserStore = useBrowserStore();
  const ipApiService = new IpApiService();

  // State
  const userGeolocation = ref<Coordinate | undefined>(undefined);
  const userCoordinatesSource = ref<UserCoordinatesSource>(
    UserCoordinatesSource.None
  );
  const isLoading = ref<boolean>(false);

  // Actions
  async function loadUserCoordinates(): Promise<void> {
    isLoading.value = true;
    if (userGeolocation.value) {
      return;
    }

    const geocodingCoordinates =
      await browserStore.loadUserCoordinatesFromGeolocationAPI();

    if (geocodingCoordinates) {
      userGeolocation.value = geocodingCoordinates;
      userCoordinatesSource.value = UserCoordinatesSource.GeolocationApi;
      isLoading.value = false;
      return;
    }

    const ipApiCoordinates = await ipApiService.getUserCoordinatesFromIPApi();

    if (ipApiCoordinates) {
      userGeolocation.value = ipApiCoordinates;
      userCoordinatesSource.value = UserCoordinatesSource.IpApi;
    }

    isLoading.value = false;
  }

  return {
    // State
    userGeolocation,
    userCoordinatesSource,
    isLoading,

    // Actions
    loadUserCoordinates,
  };
});
